import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSingleClothStock, updateClothStockEntry } from '../../Store/PHPSlice/clothStock';


const ClothStkEdit = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        dt: '',
        clstkId: parseInt(Id),
        cloth: '',
        clothId: '',
        mtr: '',
        rack: '',
        bale: '',
        newMtr: '',
        userId: '1'
    });

    const dispatch = useDispatch();

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const singleClothStock = useSelector((state) => state.ClothStockData.singleClothStock || { data: [] });
    useEffect(() => {
        dispatch(fetchSingleClothStock(Id))
    }, [dispatch, Id]);
    useEffect(() => {
        if (singleClothStock.data.length > 0) {
            const item = singleClothStock.data[0];
            setFormData({
                ...formData,
                dt: item.dt,
                cloth: item.cloth,
                clothId: item.clothId,
                mtr: item.mtr,
                bale: item.bale,
                rack: item.rack,
            });
        }
    }, [singleClothStock]);
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(updateClothStockEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                toast.success("Cloth Stock Updated");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>

            <div style={{ margin: '1% 1%' }}>
                <h2 style={{textAlign:'center'}}>Cloth Stock Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={2}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Cloth', name: 'cloth' },
                                    { label: 'Bale', name: 'bale' },
                                    { label: 'Rack', name: 'rack' },
                                    { label: 'Mtr', name: 'mtr' },
                                    { label: 'New Mtr', name: 'newMtr' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.name !== 'newMtr' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={formData.newMtr === ""}>Update</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ClothStkEdit;
